import { QueryNames } from '../enum';
import {
    AdditionalPageOptions,
    CmsButtonConfig,
} from '../interface';
import { createQueryString } from '@vfde-sails/utils';

/**
 * Get CMS config from additionalPageOptions
 */
export const getCMSConfig = () => window.additionalPageOptions as AdditionalPageOptions;

/**
 * Gets CMS config for tariff benefits
 */
export const getCMSTariffBenefits = (tariffId: string) =>
    Object.values(getCMSConfig().tariffBenefits)
        .filter(benefit => Object.values(benefit.tariffs).includes(tariffId));

/**
 * Shows every tariff footnotes at once or separately
 */
export const showAllTariffFootnotesAtOnce = () => !!getCMSConfig().footnotes.showAllAtOnce;

/**
 * Returns the given CMS button config with the updated targetURL query
 */
export const getLoginCtaCmsProps = ({ text, link }: CmsButtonConfig): CmsButtonConfig => ({
    link: `${link}${createQueryString({ [QueryNames.TargetUrl]: `${location.origin}${location.pathname}` })}`,
    text,
});
